import { Link, Outlet, useLocation } from 'react-router'
import { Building2, Link as LinkIcon, Plug } from 'lucide-react'
import { useSidebarStore } from '@/stores/sidebarStore'
import { useBrand } from '@/context/brandContext'

// Brand-scoped settings: the things that belong to the currently-selected brand
// (its details + its connected social accounts). User-level settings live under
// /account. See the sidebar split (brand-scoped nav up top, Account at the bottom).
export function SettingsPage() {
  const { isOpen } = useSidebarStore()
  const { currentBrand } = useBrand()
  const location = useLocation()

  const navLinks = [
    { label: 'Brand', to: '/settings', icon: <Building2 className="mr-2 h-4 w-4" /> },
    {
      label: 'Social Media',
      to: '/settings/social-media',
      icon: <LinkIcon className="mr-2 h-4 w-4" />,
    },
    {
      label: 'Content Connections',
      to: '/settings/connections',
      icon: <Plug className="mr-2 h-4 w-4" />,
    },
  ]

  return (
    <section className="mx-auto mt-[3vh] max-w-6xl flex-1 p-6">
      <div className="mb-4">
        <h1 className="text-foreground text-2xl font-bold">Settings</h1>
        {currentBrand && <p className="text-muted-foreground text-sm">{currentBrand.name}</p>}
      </div>

      <div className={`flex flex-col ${isOpen ? 'lg:flex-row' : 'md:flex-row'} gap-6`}>
        <div className="space-y-1 md:w-64">
          <ul className="flex h-auto w-full flex-col space-y-1 bg-transparent p-0">
            {navLinks.map(({ label, to, icon }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={`flex w-full cursor-pointer items-center rounded-md px-2 py-1.5 ${
                    location.pathname === to ? 'bg-hover' : 'hover:bg-hover'
                  }`}>
                  {icon}
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </section>
  )
}
